import { render, staticRenderFns } from "./WidgetAmount.vue?vue&type=template&id=bc77a4e0&"
import script from "./WidgetAmount.vue?vue&type=script&lang=js&"
export * from "./WidgetAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports